import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../store/hooks';
import { setToken, fetchUser } from '../store/slices/authSlice';
import { CircularProgress, Box, Typography } from '@mui/material';

const SsoCallback: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      dispatch(setToken(token));
      dispatch(fetchUser()).unwrap()
        .then(() => navigate('/getting-started'))
        .catch(() => navigate('/login'));
    } else {
      navigate('/login');
    }
  }, [dispatch, navigate]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
      <CircularProgress />
      <Typography variant="h6" sx={{ mt: 2 }}>Signing you in...</Typography>
    </Box>
  );
};

export default SsoCallback;
